

export enum AplosFileContentType {

    BinaryOctetStream = "binary/octet-stream",
    ApplicationOctetStream = "application/octet-stream",
    TextPlain = "text/plain",
    TextCsv = "text/csv",
    TextHtml = "text/html"

}